module.exports = __webpack_public_path__ + "img/cross-popup.e89f3119.svg";